<template>
  <!-- Container -->
  <div>
    <svg
      v-if="isLoading"
      xmlns="http://www.w3.org/2000/svg"
      class="mx-auto w-8 h-8 text-purple-500 stroke-current stroke-2"
      viewBox="0 0 38 38"
    >
      <g transform="translate(1 1)" fill="none">
        <circle stroke-opacity="0.5" cx="18" cy="18" r="17" />
        <path d="M35 18c0-9.3-7.6-17-17-17">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 18 18"
            to="360 18 18"
            dur="1s"
            repeatCount="indefinite"
          />
        </path>
      </g>
    </svg>

    <!-- If No Results -->
    <div
      v-if="!isLoading && posts.length == 0"
      class="flex justify-center w-full"
    >
      <span class="text-center text-gray-650 text-xl">
        {{ noResults }}
      </span>
    </div>

    <!-- Recipe Posts Wrapper -->
    <div v-if="posts" class="card-wrapper card-four-column mb-10 py-5 lg:mb-12">
      <!-- Recipe Post -->
      <a
        :href="post.link"
        v-for="post in posts"
        :key="post.id"
        class="card-body is-link"
      >
        <!-- Image -->
        <div class="card-image-wrapper card-image-four-column">
          <img
            v-if="post.featured_img_url_full"
            :srcset="post.featured_img_srcset"
            :src="post.featured_img_url_full"
            alt=""
            loading="lazy"
          />
        </div>
        <!-- Close Image -->

        <!-- Post Title -->
        <div class="card-content-wrapper">
          <h4 v-html="post.title.rendered"></h4>
        </div>
      </a>
      <!-- Close Recipe Post -->
    </div>
    <!-- Recipe Posts Wrapper -->
  </div>
  <!-- Close Container -->
</template>

<script>
// Import Getters and Actions from Vuex
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Recipes',
  props: {
    catId: {
      type: Number,
      default: null
    },
    tagId: {
      type: Number,
      default: null
    },
    labelId: {
      type: Number,
      default: null
    },
    taxonomy: {
      type: String,
      default: null
    },
    noResults: ''
  },
  computed: mapGetters(['isLoading', 'posts']),
  methods: {
    ...mapActions(['getPosts'])
  },
  mounted() {
    if (this.catId) {
      this.$store.commit('setCategory', this.catId);
    }

    if (this.tagId) {
      this.$store.commit('setTag', this.tagId);
    }

    if (this.labelId) {
      this.$store.commit('setLabel', this.labelId);
    }

    this.getPosts();
  }
};
</script>
